import { css } from '@emotion/react'
import { observer } from 'mobx-react'

import { HelpIcon, Spacer, TooltipText } from '../../../../components'
import { LightGreyText, SectionBox } from '../../styled'
import SecuritySearch from './SecuritySearch'
import SelectedSecurity from './SelectedSecurity'

/**
 * The search, or the investment it turned up, in the page's flow.
 *
 * Mobile gives each of those a screen of its own instead — see SecuritySearchScreen and the
 * focused shell in AddNewInvestment.
 *
 * @param {Object} props
 * @param {string} props.accountType account type key from the route, e.g. '401k'
 * @param {Object|null} props.security the chosen investment, if there is one
 * @param {Array} props.notInvestedInvestments investments already marked not invested
 * @param {Function} props.onSelect called with the chosen security's id
 * @param {Function} props.onClear drops the chosen investment and hands the search back
 */
const SecuritySelector = props => {
  const { accountType, security, notInvestedInvestments, onSelect, onClear } = props

  return (
    <div
      css={css`
        max-width: 540px;
      `}>
      {security ? (
        <SelectedSecurity security={security} onClear={onClear} />
      ) : (
        <div>
          <LightGreyText>Find investment</LightGreyText>

          <span
            css={css`
              padding-left: 10px;
            `}>
            <HelpIcon tooltip={TooltipText.findInvestment()} />
          </span>

          <Spacer space='5px' />

          <SectionBox>
            <SecuritySearch
              accountType={accountType}
              notInvestedInvestments={notInvestedInvestments}
              onSelect={onSelect}
            />
          </SectionBox>

          <Spacer space='25px' />
        </div>
      )}
    </div>
  )
}

export default observer(SecuritySelector)
